module.exports = __webpack_public_path__ + "static/media/cook_food_map.fd1b6139.svg";